/* Content for the Anomalous Perturbations research card */
export const HIGHLIGHTS = [
    "Academic Research",
    "Psychological Theory",
    "Theoretical Physics",
    "Experimental Design",
    "Consciousness Studies",
    "Parapsychology",
];

export const CAPTION_PRE = "Written for the Rhine Education Center's Theories of Psi course, April 2025. Coursework only: it has ";
export const CAPTION_BOLD = "not undergone peer review";
export const CAPTION_POST = ", and isn't presented as a validated scientific claim.";
